export default "__VITE_ASSET__Bgrh_O81__"